(() => {
  const COLLECTIONS = {
    'ireland-college-university-diplomas-and-transcripts': {
      locale: 'ga',
      translatedLanguage: 'Irish',
      englishButton: 'View in English',
      translatedButton: 'Féach i nGaeilge',
      title: 'Dioplómaí agus Tras-scríbhinní Coláiste/Ollscoile na hÉireann',
      description: [
        '<p>Meaitseálaimid an dearadh bunaidh agus cuirimid na séalaí cuí i bhfeidhm i ndath, in ór ardaithe nó le cabhradh, díreach mar a dhéanfadh an scoil féin. Úsáidimid pár dioplóma ar dhath comhchosúil agus teicnící priontála oiriúnacha.</p>',
        '<p>Ceannaigh dioplómaí atá cosúil le fíordhioplómaí coláiste agus ollscoile, bunaithe ar shampla atá againn. Is féidir linn sampla a thaispeáint duit ach é a iarraidh. Tá ceann de na bunachair dearaí is mó sa ghnó againn.</p>',
        '<p>Ráthaíocht muiníne 100%! Tá go leor léirmheasanna iontacha againn. Mura bhfeiceann tú a bhfuil uait, seol ríomhphost chugainn, bain úsáid as an gcomhrá nó cuir téacs chugainn agus beidh áthas orainn cabhrú leat. Tá praghsáil agus seirbhís den scoth againn — féach duit féin!</p>'
      ].join('')
    }
  };

  const sharedLanguagePacks = window.HCInternationalLanguagePacks || {};
  Object.entries(sharedLanguagePacks.collections || {}).forEach(([handle, route]) => {
    const [profileKey, title, countryName] = route;
    const profile = sharedLanguagePacks.profiles?.[profileKey];
    if (!profile) return;
    const copy = profile.collectionCopy || [];
    COLLECTIONS[handle] = {
      locale: profile.locale,
      translatedLanguage: profile.translatedLanguage,
      englishButton: profile.englishButton,
      translatedButton: profile.translatedButton,
      direction: profile.direction || 'ltr',
      title,
      description: [
        `<p>${copy[0] || ''} ${countryName || ''}.</p>`,
        `<p>${copy[1] || ''}</p>`,
        `<p>${copy[2] || ''}</p>`
      ].join('')
    };
  });

  const getCollectionHandle = () => {
    const match = window.location.pathname.match(/^\/collections\/([^/]+)\/?$/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const initialize = () => {
    const config = COLLECTIONS[getCollectionHandle()];
    if (!config) return;

    const main = document.querySelector('#MainContent');
    const heading = main?.querySelector('#CollectionSection h1.collection-title, #CollectionSection h1');
    if (!main || !heading || heading.dataset.hcCollectionLanguageReady === 'true') return;

    const description = main.querySelector('#CollectionSection [data-hc-collection-description-content] .enlarge-text');
    const currentBreadcrumb = main.querySelector('.hc-breadcrumbs__current');
    const original = {
      title: heading.textContent.trim(),
      description: description?.innerHTML || '',
      breadcrumb: currentBreadcrumb?.textContent.trim() || ''
    };

    const toggle = document.createElement('div');
    toggle.className = 'hc-collection-language-toggle';
    toggle.setAttribute('role', 'group');
    toggle.setAttribute('aria-label', 'Page language');
    toggle.innerHTML = `
      <button type="button" class="hc-collection-language-toggle__button" data-hc-collection-language="English" aria-pressed="true"></button>
      <button type="button" class="hc-collection-language-toggle__button" data-hc-collection-language="${config.translatedLanguage}" aria-pressed="false"></button>
    `;
    heading.insertAdjacentElement('afterend', toggle);
    heading.dataset.hcCollectionLanguageReady = 'true';

    const applyLanguage = (language) => {
      const translated = language === config.translatedLanguage;
      heading.textContent = translated ? config.title : original.title;
      if (description) description.innerHTML = translated ? config.description : original.description;
      if (currentBreadcrumb) currentBreadcrumb.textContent = translated ? config.title : original.breadcrumb;
      main.setAttribute('lang', translated ? config.locale : 'en');
      main.setAttribute('dir', translated ? (config.direction || 'ltr') : 'ltr');

      toggle.querySelectorAll('[data-hc-collection-language]').forEach((button) => {
        const active = button.dataset.hcCollectionLanguage === language;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
        button.textContent = button.dataset.hcCollectionLanguage === config.translatedLanguage
          ? config.translatedButton
          : config.englishButton;
      });
    };

    toggle.addEventListener('click', (event) => {
      const button = event.target.closest('[data-hc-collection-language]');
      if (!button) return;
      applyLanguage(button.dataset.hcCollectionLanguage);
    });

    const locale = document.documentElement.lang.toLowerCase();
    applyLanguage(locale === config.locale || locale.startsWith(`${config.locale}-`)
      ? config.translatedLanguage
      : 'English');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
